import * as React from "react"
import * as SwitchPrimitives from "@radix-ui/react-switch"

import { cn } from "@/domains/library"

export const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, id, checked, onCheckedChange, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      "peer inline-flex h-[20px] w-[36px] shrink-0 cursor-pointer",
      "items-center rounded-full",
      // "from-p200-shade via-p300 to-p300-shade",
      "bg-p300",
      "p-[1px] pt-[2px]",
      "outline outline-p300-shade",
      // "shadow-[0px_1px_0px_0px_hsla(0,0%,100%,0.12)_inset] ",
      "transition-colors duration-300 ease-in-out",
      "disabled:cursor-not-allowed disabled:opacity-50 ",

      "data-[state=unchecked]:outline-p200",
      "data-[state=unchecked]:hover:brightness-[1.15]",
      "data-[state=checked]:bg-primary ",
      "data-[state=checked]:outline-none",
      className,
    )}
    id={id}
    checked={checked}
    onCheckedChange={onCheckedChange}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        "pointer-events-none ",
        "block h-[16px] w-[16px] rounded-full bg-white",
        "shadow-[0px_-1px_1px_0px_hsla(0,0%,0%,0.44)_inset]",
        "transition-transform duration-300 ease-in-out",
        "data-[state=checked]:translate-x-[17px] data-[state=unchecked]:translate-x-[1px]",
      )}
    />
  </SwitchPrimitives.Root>
))
Switch.displayName = SwitchPrimitives.Root.displayName
